import { Avatar, Box, Card, CardHeader, Divider, Typography, useMediaQuery } from '@mui/material';
import type { Theme } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { PropertyList } from '../../../../components/atoms/property-list';
import { PropertyListItem } from '../../../../components/atoms/property-list-item';

import { Host } from '@/features/hosts/api/types/host';
import { getHostDisplayData } from '@/utils/get-host-display-data';

interface Props {
  host?: Host | null;
  kioskEnteredHostName?: string | null;
}

export const VisitHost = ({ host, kioskEnteredHostName }: Props) => {
  const mdDown = useMediaQuery((theme: Theme) => theme.breakpoints.down('md'));
  const { t } = useTranslation(['visit', 'common']);
  const align = mdDown ? 'vertical' : 'horizontal';
  const { hostName, hostAvatarText } = getHostDisplayData({ host, kioskEnteredHostName });

  return (
    <Card variant="outlined">
      <CardHeader title={t('visit:host.cardTitle')} />
      <Divider />
      <Box sx={{ display: 'flex', alignItems: 'center', px: 3, pt: 2, pb: 1 }}>
        <Avatar
          sx={{
            height: 36,
            mr: 1,
            width: 36,
          }}
          variant="rounded"
          src={''}>
          <Typography>{hostAvatarText || 'N/A'}</Typography>
        </Avatar>
        {hostName}
      </Box>
      <PropertyList>
        <PropertyListItem align={align} label="Email" value={host?.email ? host.email : '-'} />
        <PropertyListItem
          align={align}
          label={t('visit:host.phoneNumber')}
          value={host?.phoneNumber ? host.phoneNumber : '-'}
        />
        <PropertyListItem
          align={align}
          label={t('visit:host.canInviteToParking')}
          value={host?.allowInviteToParking ? t('common:yes') : t('common:no')}
        />
      </PropertyList>
    </Card>
  );
};
